import { CertificateRequestStatus } from "@tfg/db/browser"
import { StatusBadge } from "@tfg/ui"
import type { ReactNode } from "react"

import { useGetCertificateRequestStatus } from "~/pages/Brand/Certificates/hooks/useCertificateRequestStatusDetails"

type Props = {
  certificateRequestStatus: CertificateRequestStatus
  userType: "brand" | "supplier"
  rightSection?: ReactNode
}

export function CertificateRequestStatusBadge({
  certificateRequestStatus,
  userType,
  rightSection,
}: Props) {
  const certificateRequestStatusDetails = useGetCertificateRequestStatus(
    certificateRequestStatus,
    userType
  )
  if (!certificateRequestStatusDetails) return null
  return (
    <StatusBadge
      size="sm"
      text={certificateRequestStatusDetails.translation}
      variant={certificateRequestStatusDetails.variant}
      icon={null}
      rightSection={rightSection}
    />
  )
}
